import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_USERS_SERVER } from '@/app/module/user/definitions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetUsers = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getOrgUserList.useQuery({ orgId: orgId.toString() }, { skip: !orgId })

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-users-error': {
          type: 'error',
          message: getErrorMessage(res.error, ERROR_GET_USERS_SERVER),
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
